import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {AccountingAccountSelectFilterComponent} from './accounting-account-select-filter.component';
import {SelectFilterModule} from '../../../../../../components/common/select-filter/select-filter.module';
import {MultipleSelectFilterModule} from '../../../../../core/component/multiple-select-filter/multiple-select-filter.module';
import {
    UserSummaryFieldModule
} from "../../../../../account/modules/user/api/component/user-summary-field/user-summary-field.module";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        SelectFilterModule,
        MultipleSelectFilterModule,
        UserSummaryFieldModule,
    ],
    declarations: [
        AccountingAccountSelectFilterComponent
    ],
    exports: [
        AccountingAccountSelectFilterComponent
    ]
})
export class AccountingAccountSelectFilterModule {
}
